<script>
import JobAd from './components/JobAd.vue';

export default {
  name: 'App',
  components: {
    JobAd
  }
}
</script>

<template>
  <div id="app">
    <JobAd/>
  </div>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>






